interface MegaMenuBlocks {
    search: HTMLDivElement | null;
    contact: HTMLDivElement | null;
    [key: string]: HTMLDivElement | null;
}

const blocks: MegaMenuBlocks = {
    search: null,
    contact: null,
};

export function initMenuBlocks(): void {
    blocks.search = blocks.search || (document.getElementById('mega-menu-block--search') as HTMLDivElement);
    blocks.contact = blocks.contact || (document.getElementById('mega-menu-block--contact') as HTMLDivElement);

    if (!blocks.search) console.warn('Did not find search block for menu!');
    if (!blocks.contact) console.warn('Did not find contact block for menu!');

    if (!blocks.search || !blocks.contact) setTimeout(initMenuBlocks, 0);
}

export function renderMenuBlock(element: HTMLElement, type: string): void {
    const block = blocks[type];
    if (block) element.appendChild(block);
}

export function removeMenuBlock(type: string): void {
    const block = blocks[type];
    if (!block) return;
    const parent = block.parentNode;
    if (!parent) return;
    parent.removeChild(block);
}
